
export default {
  name: 'TheLogo',
}
